import { Receipt, Plus, Minus, Trash2 } from "lucide-react";

export default function OrderItemsList({ allItems, onUpdateQuantity, onRemoveItem }) {
  if (allItems.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400">
        <Receipt className="w-10 h-10 mx-auto mb-2 opacity-30" />
        <p className="text-sm">Nenhum item na conta</p>
      </div>
    );
  }

  return (
    <div className="divide-y">
      {allItems.map((item, idx) => (
        <div key={idx} className="px-4 py-3 flex items-center gap-3" data-testid={`order-item-${idx}`}>
          <div className="flex items-center gap-1 shrink-0">
            <button
              onClick={() => onUpdateQuantity(item, -1)}
              className="w-7 h-7 rounded-full bg-red-50 flex items-center justify-center active:scale-95"
              data-testid={`item-minus-${idx}`}
            >
              <Minus className="w-3 h-3 text-red-500" />
            </button>
            <span className="w-8 text-center text-sm font-bold text-gray-600">
              {item.quantity}x
            </span>
            <button
              onClick={() => onUpdateQuantity(item, 1)}
              className="w-7 h-7 rounded-full bg-emerald-50 flex items-center justify-center active:scale-95"
              data-testid={`item-plus-${idx}`}
            >
              <Plus className="w-3 h-3 text-emerald-500" />
            </button>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-800 truncate">{item.product_name}</p>
            <p className="text-xs text-gray-400">€{item.unit_price?.toFixed(2)} cada</p>
          </div>
          <span className="text-sm font-bold text-gray-700">
            €{(item.quantity * item.unit_price).toFixed(2)}
          </span>
          <button
            onClick={() => onRemoveItem(item)}
            className="w-7 h-7 rounded-full bg-red-50 flex items-center justify-center active:scale-95"
            data-testid={`item-remove-${idx}`}
          >
            <Trash2 className="w-3 h-3 text-red-500" />
          </button>
        </div>
      ))}
    </div>
  );
}
